import { getRaw, ApiMethod, postRaw } from 'services/api';
import { useRestMutation, useRestQuery, UseRestMutationOptions } from 'utils/hooks/api';
import type {
  DefaultSender,
  AuthedEmail,
  DeleteAndReplaceEmailSender,
} from 'modules/senders/types';
import { createSenderRequest } from 'modules/senders/actions';

export const GET_SENDERS_DATA = '/settings/senders.json';
export const CREATE_SMS_SENDER_URL = '/settings/smsSender/create';
export const SET_DEFAULT_SENDER = '/settings/setDefaultSender';
export const CREATE_EMAIL_SENDER_URL = '/settings/sender/create';
export const EDIT_SENDER = '/settings/editSender';
export const DELETE_SENDER = '/settings/deleteSender';

/**
 * Get endpoint for fetching senders
 */
export const getSenders = () => getRaw(GET_SENDERS_DATA);

export const setDefaultSender = (defaultSender: DefaultSender) =>
  postRaw(SET_DEFAULT_SENDER, defaultSender);

export const useSmsSendersQuery = () => useRestQuery(GET_SENDERS_DATA);
export const useCreateSmsSender = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_SMS_SENDER_URL, ApiMethod.post, options);

export const createEmailSender = (data: ReturnType<typeof createSenderRequest>['data']) =>
  postRaw(CREATE_EMAIL_SENDER_URL, data);

export const editSender = (sender: AuthedEmail) => postRaw(EDIT_SENDER, sender);

export const deleteSender = (deleteAndReplaceSender: DeleteAndReplaceEmailSender) =>
  postRaw(DELETE_SENDER, deleteAndReplaceSender);
